module.exports = __webpack_public_path__ + "static/51-215ae92879a56ad4f7df96d2412b6732.jpg";